import { SocialIcon } from "../AudienceIcons";
import type { StepProps } from "./types";

export function createCustomAudienceLookalikeOptions(): StepProps["lookalikeOptions"] {
  return [
    {
      title: "Create 0-1% lookalike",
      description: "",
      value: "0-1",
      icon: <SocialIcon />,
      iconBgColor: "#DFEAFD",
      isRecommended: true,
    },
    {
      title: "Create 0-3% lookalike",
      description: "",
      value: "0-3",
      icon: <SocialIcon />,
      iconBgColor: "#FDF5DF",
      isRecommended: false,
    },
    {
      title: "Create 0-5% lookalike",
      description: "",
      value: "0-5",
      icon: <SocialIcon />,
      iconBgColor: "#FDE3DF",
      isRecommended: false,
    },
  ];
}
